

import React from "react";
import { OfferOptionsFieldProps } from "./OfferOptionsField.type";
import { Box, CircularProgress, MenuItem, TextField } from "@mui/material";

export const OfferOptionsField = ({
    value = [],
    onChange,
    optionTypes = [],
    loading,
}: OfferOptionsFieldProps) => {
    if (loading) return <CircularProgress />;

    return (
        <Box sx={{ my: 2 }}>
            {optionTypes.map((type) => {
                const selected =
                    value.find((v) => v.offerOptionsTypeId === type.id)?.offerOptionsValueId ?? "";

                return (
                    <TextField
                        key={type.id}
                        select
                        fullWidth
                        margin="normal"
                        size="medium"
                        label={`Wybierz ${type.name}`}
                        value={selected}  // "" na start, więc placeholder się pokazuje
                        onChange={(e) => {
                            const val = Number(e.target.value);
                            const current = value.slice();
                            const idx = current.findIndex((v) => v.offerOptionsTypeId === type.id);
                            if (idx >= 0) {
                                current[idx].offerOptionsValueId = val;
                            } else {
                                current.push({
                                    offerOptionsTypeId: type.id,
                                    offerOptionsValueId: val,
                                });
                            }
                            onChange(current);
                        }}
                    >
                        <MenuItem value="" disabled>
                            <em>Wybierz wartość...</em>
                        </MenuItem>
                        {(type.offerOptionsValues ?? []).map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.value ?? option.shortName ?? String(option.id)}
                            </MenuItem>
                        ))}
                    </TextField>
                );
            })}
        </Box>
    );
};
